import ImageHighlightStory from './ImageHighlightStory'
import DocumentHighlightStory from './DocumentHighlightStory'
import PlaylistHighlightStory from './PlaylistHighlightStory'
import TextHighlightStory from './TextHighlightStory'
import VideoResponseHighlightStory from './VideoResponseHighlightStory'
import WorkspaceVideoClipHighlightStory from './WorkspaceVideoClipHighlightStory'
import RichText from './RichText'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { camelize } from 'humps'

export default class HighlightStory extends Component {
  static propTypes = {
    highlightStory: PropTypes.object.isRequired,
    isFocused: PropTypes.bool.isRequired,
    onFocus: PropTypes.func.isRequired,
    onLoseFocus: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.onFocus = this.onFocus.bind(this)
    this.onLoseFocus = this.onLoseFocus.bind(this)
  }

  onFocus() {
    const { highlightStory, onFocus } = this.props
    onFocus(highlightStory)
  }

  onLoseFocus() {
    const { highlightStory, onLoseFocus } = this.props
    onLoseFocus(highlightStory)
  }

  renderContent() {
    const { highlightStory, isFocused } = this.props
    const content = highlightStory.content

    if (!content || !content.kind) {
      return null
    }

    switch (camelize(content.kind)) {
      case 'imageDocumentClip':
      case 'workspaceImageClip':
        return (
          <ImageHighlightStory
            image={content.image}
            isExpanded={isFocused}
            onCollapseClick={this.onLoseFocus}
            onExpandClick={this.onFocus}
            title={content.name}
          />
        )
      case 'imageResponse':
        return (
          <ImageHighlightStory
            image={content.image}
            isExpanded={isFocused}
            onCollapseClick={this.onLoseFocus}
            onExpandClick={this.onFocus}
            title={content.title}
          />
        )
      case 'projectDocument':
      case 'workspaceDocument':
        return (
          <DocumentHighlightStory
            isExpanded={isFocused}
            onExpandClick={this.onFocus}
            onCollapseClick={this.onLoseFocus}
            document={content}
          />
        )
      case 'playlist':
        return (
          <PlaylistHighlightStory
            isPlaying={isFocused}
            onPlay={this.onFocus}
            onEnded={this.onLoseFocus}
            playlist={content}
          />
        )
      case 'textResponse':
        return <TextHighlightStory text={content.commentTxt} />
      case 'textDocumentClip':
      case 'workspaceTextClip':
        return <TextHighlightStory text={content.textSelection} />
      case 'videoResponse':
        return (
          <VideoResponseHighlightStory
            videoResponse={content}
            isPlaying={isFocused}
            onEnded={this.onLoseFocus}
            onPlay={this.onFocus}
          />
        )
      case 'workspaceVideoClip':
        return (
          <WorkspaceVideoClipHighlightStory
            workspaceVideoClip={content}
            isPlaying={isFocused}
            onEnded={this.onLoseFocus}
            onPlay={this.onFocus}
          />
        )
    }
  }

  render() {
    const { highlightStory } = this.props

    return (
      <div className="insight-story-container clearfix">
        <div className="insight-story-item">{this.renderContent()}</div>
        <div className="insight-story-text">
          <RichText text={highlightStory.text} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/HighlightStory.js